module.exports = __webpack_public_path__ + "static/media/blog_56.63e4a2ff.webp";